import React, { Component } from 'react';
import {Divider, Header, Segment, Button, Message} from 'semantic-ui-react';
import { Formik, Form, Field } from 'formik';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import RegisterEmailSchema from './validate';

class FormsRegisterEmail extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there is an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        const {updateStepIndex, name, emailProvided, emailEditable, requireRegistrationEmail, contactNoCountryCode, contactNo} = this.props;
        return (
            <Formik
                initialValues={{
                    email: emailProvided ? emailProvided :'',
                    contactNo: contactNo ? contactNo : '',
                    contactNoCountryCode: contactNoCountryCode ? contactNoCountryCode : ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={RegisterEmailSchema}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    this.setState({error: false, errorMessage: null});
                    this.props.registerGenerateOTPEmail({
                        nric: this.props.identifier,
                        email: values.email,
                        contactNoCountryCode: values.contactNoCountryCode,
                        contactNo: values.contactNo
                    }, (result, error) => {
                        console.log(result, error);
                        if (error) {
                            this.setState({error: true, errorMessage: error.errorMessage});
                            actions.setSubmitting(false);
                        }
                        if (result) {
                            updateStepIndex(4, {email: values.email});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Segment>
                        <Form>
                            <Header as='h2'>
                                Email Address
                            </Header>
                            <Divider />
                            <Message warning>
                                <Message.Header>
                                    Thank you, {name}!
                                </Message.Header>
                                <p>
                                    Please input your email address to proceed.
                                    <br />
                                    <b>
                                        Note: Your email address will be your username for login.
                                    </b>
                                </p>
                            </Message>
                            <Field name="email" label="" component={FormsInputsText} secondaryLabel="Email" disabled = {!emailEditable}/>
                            &nbsp;
                            <Button type="submit" primary disabled={isSubmitting} fluid loading={isSubmitting}>Verify Email Address</Button>
                            <p>
                                &nbsp;
                            </p>
                            {
                                this.renderFormSubmissionResult()
                            }
                        </Form>
                    </Segment>
                )}
            />
        );
    }
}

export default FormsRegisterEmail;